import Actions from '../../odata/actions';

const actions = new Actions('formSignature', 'formSignatures');

export default actions;
